import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, Box} from 'views/components';

import {Translate, translate, ClientAutocomplete} from 'views/module';

const AddClient = (props) => {
  const [client, setClient] = React.useState(null);

  const onClose = props.onClose;
  const addClient = props.addClient;

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.ClientConnections.AddClient.Title' />
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            p: 1,
          }}
        >
          <ClientAutocomplete
            label={translate('caregiver.CaregiverDetail.ClientConnections.AddClient.ClientSearch')}
            selectedClient={client}
            setSelectedClient={setClient}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="error" variant="contained" onClick={() => addClient(client.clientRn)}>
          <Translate expression='caregiver.CaregiverDetail.ClientConnections.AddClient.AddClient' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddClient.propTypes = {
  onClose: PropTypes.func.isRequired,
  addClient: PropTypes.func.isRequired,
};

export default React.memo(AddClient);
